<div class="px-4 py-5 d-flex flex-column align-items-center">
    <h2 class="heading-text mb-4">{{'SwalMessages.Wait'|translate}}</h2>
    <mat-progress-bar mode="indeterminate"></mat-progress-bar>
</div>
